export default "__VITE_ASSET__CG$zRDSU__"